import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  constructor() {}

  setCookie(name: string, value: string, days: number = 30, path: string = '/') {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=${path}`;
  }

  getCookie(name: string): string {
    const nameEQ = `${name}=`;
    const cookiesArray = document.cookie.split(';');
    const cookie = cookiesArray.find(cookie => cookie.trim().startsWith(nameEQ));
    return cookie ? cookie.trim().substring(nameEQ.length) : '';
  }

  deleteCookie(name: string, path: string = '/') {
    this.setCookie(name, '', -1, path);
  }
}
